import React, { useState } from "react";
import "./contactform.css";
import { IoClose } from "react-icons/io5";

function ContactForm({ close }) {
  // ---------------- FORM STATES ----------------
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  // Handle Input Change
  const handleChange = (e) => {
    setFormData({ 
      ...formData, 
      [e.target.name]: e.target.value 
    });
  };

  // Handle Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");

    try {
      const response = await fetch("https://sales.redite.in/php/sendemail.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      console.log("Server response:", result);

      if (result.success) {
        setStatus("Mail sent successfully ✔");

        // CLEAR FORM
        setFormData({
          name: "",
          phone: "",
          email: "",
          message: "",
        });
      } else {
        setStatus("Failed to send mail ❌");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setStatus("Error sending mail ❌");
    }

    setLoading(false);
  };

  return (
    <div className="popup-overlay">
      <div className="popup-box">

        <div className="popup-header">
          <h3>Contact Form</h3>
          <IoClose className="close-btn" onClick={close} />
        </div>

        <form className="popup-body" onSubmit={handleSubmit}>
          <input 
            type="text" 
            name="name"
            placeholder="Name*" 
            value={formData.name}
            onChange={handleChange}
            required
          />

          <input 
            type="text"
            name="phone"
            placeholder="Phone*" 
            value={formData.phone}
            onChange={handleChange}
            required
          />

          <input 
            type="email"
            name="email"
            placeholder="Email*" 
            value={formData.email}
            onChange={handleChange}
            required
          />

          <textarea
            name="message"
            placeholder="Message"
            value={formData.message}
            onChange={handleChange}
            required
          ></textarea>

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? "Sending..." : "Submit"}
          </button>

          {status && <p className="form-status">{status}</p>}
        </form>
      </div>
    </div>
  );
}

export default ContactForm;
